import React from 'react';
import { Progress } from '@backstage/core-components';
import { ConfigApi, configApiRef, useApi } from '@backstage/core-plugin-api';
import { DxIFrame } from '@internal/backstage-plugin-dx-iframe';
import { useUser } from './userManagement/hooks';

function getSystemStatusUrl(configApi: ConfigApi, isInternal: boolean): string {
  const defaultUrl = configApi.getString('dxmSystemStatus.url');
  if (!isInternal) {
    return defaultUrl;
  }

  return (
    configApi.getOptionalString('dxmSystemStatus.advancedUrl') || defaultUrl
  );
}

export function SystemStatusPage() {
  const configApi = useApi(configApiRef);
  const { data: user, isPending } = useUser('me');

  if (isPending) {
    return <Progress />;
  }

  return (
    <DxIFrame
      type="system-status"
      url={getSystemStatusUrl(configApi, !!user?.isInternal)}
    />
  );
}
